<div style="position: relative; height:450px;width: 100%;" fxLayout="column" fxLayoutAlign="center center">
    <div #map [style.width]="width" [style.height]="height"></div>
    <div [hidden]="isMapAvailabel" class="overlay"></div>
    <div [hidden]="isMapAvailabel" class="overlay-message">
        <h4> No map available for current selection criteria</h4>
    </div>
</div>
<!-- [ngClass]="{'loading': loading, 'loaded': !loading}" -->
